import { Injectable } from '@angular/core';
import { UsageService } from '../usage/usage.service';

/** The app's named actions, counted in REMOAT's usage report (this used to send them to Google Analytics). */
@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(private usage: UsageService) { }

  trackEvent(eventName: string, eventCategory: string, eventLabel: string, _value: number) {
    this.usage.action(`${eventCategory}: ${eventLabel}`);
  }

  trackButtonClick(buttonName: string) {
    this.usage.action(buttonName);
  }

  trackSystemEvent(eventName: string, action: string) {
    this.usage.action(`${action}: ${eventName}`);
  }
}
